/* eslint-disable react-hooks/exhaustive-deps */
import { useState,useContext,useEffect } from 'react';
import { useMutation, } from "@apollo/client";
import { AdminContext } from "../../../context/AdminContext/AdminContext";
import { CREATE_ADD_EVAL_EXT_PER_EVAL,
         GET_PEFORMANCE_EVALUATION_COLLBORATORS,
         UPDATE_ADD_EVAL_EXT_PER_EVAL} from "../../../Querys/performanceEvaluation/querys";
import PerformanceEvaluationContext from "../../../context/PerformanceEvaluationContext/PerformanceEvaluationContext";
import {closeColExtPerEvalModal } from "../../../context/PerformanceEvaluationContext/Actions";
import {
    Dialog,
    DialogTitle,
    DialogContent,  
    TextField,
 } from '@material-ui/core';
 import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingAlert } from "../../../alerts/loadingAlerts";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import { ErrorAlert } from "../../../alerts/errorAlert";


const ModalExternoEvelPerformance = () => {
  const { adminState } = useContext(AdminContext)    
  const {state, dispatch} = useContext(PerformanceEvaluationContext); 
  const id= state._id 
    const [buttonDisabled,setButtonDisabled]=useState(false); 
    const [nameModal, setNameModal] = useState("")
    const [nameBtn, setNameBtn] = useState("")
    const [msjError, setMsjError] = useState("")
    
    const [updateEvalExt,setUpdateEvalExt]=useState(false); 
    const [initialValuesForm,setInitialValuesForm] = useState(
      {
        nameEvaluadorExterno: "",     
        emailEvaluadorExterno:""
    }
  );

  const [createEvalExtEvalPer] = useMutation(CREATE_ADD_EVAL_EXT_PER_EVAL, {
    
    refetchQueries: [
        {
          query: GET_PEFORMANCE_EVALUATION_COLLBORATORS ,
          variables: { idPerEval:id, idCompany:adminState?.idEnterprise },
        },
    ],
  });

  const [updateEvalExtPer] = useMutation(UPDATE_ADD_EVAL_EXT_PER_EVAL, {
    
    refetchQueries: [
      { 
        query: GET_PEFORMANCE_EVALUATION_COLLBORATORS ,
        variables: { idPerEval:id, idCompany:adminState?.idEnterprise},
      },
  ],
  });
   
  const closeModalEvalExterno=()=>{
     formik.resetForm();    
     setUpdateEvalExt(false) 
     closeColExtPerEvalModal(id.toString(),null,false, dispatch)      
}
const typesArray = ['lider-ext', 'colegas-ext', 'subornidados-ext', 'clientes-ext']
useEffect(() => {
  
  if (state.infoEvalExt !== null) {
    setNameModal("Actualizar evaluador")
    setNameBtn("Actualizar")
    setMsjError('editar')
    setUpdateEvalExt(true)
    switch (state.typeArray) {
      case  typesArray[0]:       
        return   setInitialValuesForm({ 
        nameEvaluadorExterno: state.infoEvalExt[0].lider[0].name,     
        emailEvaluadorExterno:state.infoEvalExt[0].lider[0].email
        });

      case  typesArray[1]:
         return   setInitialValuesForm({ 
          nameEvaluadorExterno: state.infoEvalExt[0].colega[0].name,     
          emailEvaluadorExterno:state.infoEvalExt[0].colega[0].email
          });  

      case  typesArray[2]:        
          return   setInitialValuesForm({ 
          nameEvaluadorExterno: state.infoEvalExt[0].subornidado[0].name,     
          emailEvaluadorExterno:state.infoEvalExt[0].subornidado[0].email
          });     

      case  typesArray[3]:        
          return   setInitialValuesForm({ 
            nameEvaluadorExterno: state.infoEvalExt[0].cliente[0].name,     
            emailEvaluadorExterno:state.infoEvalExt[0].cliente[0].email
            });     
     }
    
  }
  else{
    setNameModal("Agregar evaluador")
    setUpdateEvalExt(false)
    setInitialValuesForm({ 
      nameEvaluadorExterno: '',     
      emailEvaluadorExterno:''
    });
    setNameBtn("Agregar")
    setMsjError('crear')
  }
}, [state, state.infoEvalExt ]);

const validationSchema = () => {               
    return {
      nameEvaluadorExterno: Yup.string().required("Obligatorio"),
      emailEvaluadorExterno: Yup.string().email('Ingrese un formato válido').required('Obligatorio'),
    }      
  }

  const formik = useFormik({
    initialValues: initialValuesForm,
    enableReinitialize: true,      
    validationSchema: Yup.object(validationSchema()),
    onSubmit: async (formData, { resetForm }) => {  
      let newValues={
      ...formData,
      idPerEval:parseInt(state._id),
      idUsuario:state.idUser,
      tipo:state.typeArray
     }          
      try {  
        
        setButtonDisabled(true)
        LoadingAlert({ title: "Agregando..." }); 
        if(!updateEvalExt){
         await createEvalExtEvalPer({
           variables: {
            input: newValues,
           },
         });
         SuccessfulAlert({ text: "Evaluador creado correctamente."});
        }else
        {
         let copyValues:any
          switch (state.typeArray) {
            case  typesArray[0]:  
             copyValues={...newValues,id:state.infoEvalExt[0].lider[0].id}          
            break;
            case  typesArray[1]:  
             copyValues={...newValues,id:state.infoEvalExt[0].colega[0].id}          
            break;
            case  typesArray[2]:  
               copyValues={...newValues,id:state.infoEvalExt[0].subornidado[0].id}  
            break;
            case  typesArray[3]:  
              copyValues={...newValues,id:state.infoEvalExt[0].cliente[0].id}  
              break;
          }         
          await updateEvalExtPer({
                 variables: {
                  input: copyValues,
                 },
               });   
           SuccessfulAlert({ text: "Evaluador actualizado correctamente."});          
        }
         setButtonDisabled(false)
         closeModalEvalExterno()
      }
      catch (e) {
      ErrorAlert({ text: `Ocurrió un error al ${msjError} al evaluador`});
      console.log("error",e)
      setButtonDisabled(false)
    }
    }  
  });  

  return (
    <>    
    <Dialog 
           open={state.modalCollaboratorExternoPerformanceEvaluation}
           aria-labelledby="form-dialog-title" 
           className="dialogPrestacion"         
           >
        <IconButton aria-label="close" 
          onClick={(()=> {closeModalEvalExterno() } )}
          sx={{position: 'absolute', right: 8, top: 8,color: (theme) => theme.palette.grey[500], }}
           >
          <CloseIcon />
        </IconButton>     
       <DialogContent  >
       <Form 
          className="containerMdalPrestacion" 
          onSubmit={formik.handleSubmit} 
          >  
        <DialogTitle  className="titleModalPerformanceEval" ><span className="txtTitleModalPerformanceEval">{nameModal}</span></DialogTitle>
        <DialogContent className="oneComponentExternos">
              <TextField
                type="text"
                name="nameEvaluadorExterno"
                label="Nombre del nuevo evaluador*"
                variant="outlined"
                size="small"
                fullWidth={true}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                inputProps={{ maxLength: 50 }}
                value={formik.values.nameEvaluadorExterno}
                 onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                 error={formik.touched.nameEvaluadorExterno && Boolean(formik.errors.nameEvaluadorExterno)}
                 helperText={formik.touched.nameEvaluadorExterno && formik.errors.nameEvaluadorExterno}
              />
            </DialogContent>
            <DialogContent className="oneComponentExternos">
              <TextField
                type="text"
                name="emailEvaluadorExterno"
                label="Correo electrónico*"
                variant="outlined"
                size="small"
                fullWidth={true}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                inputProps={{ maxLength: 50 }}
                value={formik.values.emailEvaluadorExterno}
                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                error={formik.touched.emailEvaluadorExterno && Boolean(formik.errors.emailEvaluadorExterno)}
                 helperText={formik.touched.emailEvaluadorExterno && formik.errors.emailEvaluadorExterno}
              />
            </DialogContent>
  
          <DialogContent className="twoComponentBtns">
              <div className="containerButtons">
                <div className="containerCancelPreestacion">
                  <button className="btnCancelPrestacion" type="button"
                    onClick={(() => {
                      formik.resetForm();
                      closeModalEvalExterno();                
                    }
                    )}>
                    Cancelar
                  </button>
                </div>
                <div className="containerAddPrestacion">
                  <button className="btnAddPrestacion" type="submit" 
                   disabled={buttonDisabled}
                  >
                    <div className="infobtnAddRestriccion">                 
                      <div><span className="txtBtnAdd">{nameBtn}</span> </div>
                    </div>
                  </button>
                </div>
              </div>
          </DialogContent>   
          </Form>    
       </DialogContent>     
    </Dialog>        
    </>
  )
}

export default ModalExternoEvelPerformance